export const SET_GUIDE_STEPS = "SET_GUIDE_STEPS";
export const UPDATE_TOUR_STATE = "UPDATE_TOUR_STATE";
export const UPDATE_TOUR_STATUS = "UPDATE_TOUR_STATUS";
export const TOUR_SKIP_CHECK = "TOUR_SKIP_CHECK";
export const OPEN_SLIDER = "OPEN_SLIDER";
